const MARKER_PROJECT_IDS = {
	staging: "67bf3075559a9a1b667c7c8c",
	live: "68f0f3d110b48c08800c9cd7",
} as const;

const STAGING_ENVS = ["test", "canary", "preprod"] as const;

/** Maps a deployment environment to its Marker.io project id, if any. */
export const getMarkerProjectId = (env: string) => {
	if (STAGING_ENVS.some(name => env.includes(name))) {
		return MARKER_PROJECT_IDS.staging;
	}

	if (env.includes("live")) {
		return MARKER_PROJECT_IDS.live;
	}

	return undefined;
};
